import React, {FC, useEffect, useState} from 'react';
import {useAction} from "../../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../../store/hooks/useTypedSelector";
import {Link} from "react-router-dom";
import {Accordion} from "react-bootstrap";

interface STLProps {
    atagParams: string | null
    viewType?: string | null
    eventKey: string
    ticketOpenMode: string | null
    sourceParams: string | null,
}
const SmartbetLobbyWidget: FC <STLProps> = ({atagParams, viewType,ticketOpenMode,eventKey, sourceParams}) => {
    const {getSmartBetsData} = useAction();
    const {smartBetsData} = useTypedSelector((state) => state.smartBetsReducer);
    const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;

    useEffect(()=>{
        getSmartBetsData();
    }, [])
    return(
        <>
            {smartBetsData.length > 0 ?
                <Accordion.Item eventKey={eventKey} className='cursor-pointer'>
                    <Accordion.Header>SmartBet</Accordion.Header>
                    <Accordion.Body>
                        <ul
                            style={{
                                listStyle: 'none',
                                padding: '0'
                            }}
                        >
                            {
                                smartBetsData.length > 0 ?
                                    smartBetsData.map((item: any, index: number) => {
                                        return (
                                            <li
                                                key={`${index}smartBetsData`}
                                                className='mt-2'
                                            >
                                                <Link
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'left',
                                                        alignItems: ' center'
                                                    }}
                                                    to={(() => {
                                                        let url = `smartbet/${item.code}`;
                                                        const params = new URLSearchParams();

                                                        if (atagParams) params.append('atag', atagParams);
                                                        if (sourceParams) params.append('source', sourceParams);
                                                        if (viewType) params.append('viewType', viewType);
                                                        const queryString = params.toString();
                                                        if (queryString) url += `?${queryString}`;

                                                        return url;
                                                    })()}
                                                    className='smartbet-card-link text-decoration-none  sidebar-ticket-link'
                                                    target={ticketOpenMode === 'redirect' ? '_blank' : undefined}
                                                >
                                                    <img
                                                        src={`${item.preview_img}`}
                                                        onError={(e) => {
                                                            e.currentTarget.src = toAbsoluteUrl('/assets/img/events/league/F2964C.png');
                                                        }}
                                                        width='35'
                                                        height='35'
                                                        alt="sb-logo"
                                                        style={{
                                                            borderRadius: "1rem"
                                                        }}
                                                    />
                                                    <div style={{marginLeft: '10px'}} className='text-center text-green'>
                                                       {item.title && item.title.length > 0 ? item.title : "Smartbet"}
                                                    </div>
                                                </Link>

                                            </li>
                                        )
                                    }) : null
                            }
                        </ul>
                    </Accordion.Body>
                </Accordion.Item>

                : 'Loading...'
            }
        </>
    )

}

export default SmartbetLobbyWidget;
